/*
  La Sura - the quiz's results, refined with what the store actually has ("Paths and polish"
  plan: results that remember the answers). Runs after the routing table in
  assets/lasura-quiz.js (which stays the one place the question tree routes, and sits at the
  page-weight limit), through window.lasuraQuizRefine(result, state, copy).

  - Occasion: "Browse our cakes", wherever it sits in the result, becomes the occasion's own
    collection (Birthdays, Anniversaries, Baby showers) when it has products.
  - This week: "In the next few days" leads with Need it soon?, the bakes that can be ready in
    time, with the wider range second.
  - Never a dead end: a collection with no products (copy.counts, from Liquid) is taken out. If
    that was the vegan and gluten-free range, the result says so and offers to ask instead.
  - Delivery: a Collect or Local delivery answer opens the collection already filtered to it,
    the same tag URL the collection's "How's it getting to you?" row uses.
  Every label, URL and note is a hardcoded path or a section setting; nothing typed enters.
*/
window.lasuraQuizRefine = (r, s, copy) => {
  const counts = copy.counts || {};
  const has = (handle) => !(handle in counts) || counts[handle] > 0;
  const C = (key, fallback) => copy[key] || fallback;
  const L = (label, url) => ({ label, url });
  const handleOf = (url) => (/^\/collections\/([a-z0-9-]+)$/.exec(url) || [])[1];
  const occasions = { Birthday: 'birthdays', Anniversary: 'anniversaries', 'Baby celebration': 'baby-showers' };
  const browse = (url) => url === '/collections/cakes' || Object.values(occasions).includes(handleOf(url));
  const enquiry = () => '/pages/bespoke-enquiry' + (s.occasion ? '?occasion=' + encodeURIComponent(s.occasion) : '');
  let links = [r.primary, ...r.secondary];

  const occasion = occasions[s.occasion];
  if (occasion && has(occasion)) {
    const label = C('occasion_cakes', 'See our [occasion] cakes').replace('[occasion]', s.occasion.toLowerCase());
    links = links.map((l) => (l.url === '/collections/cakes' ? L(label, '/collections/' + occasion) : l));
  }

  /* An empty collection is never offered. */
  const before = links.length;
  links = links.filter((l) => has(handleOf(l.url)));
  const dietary = s.dietary || [];
  if (links.length < before && (dietary.includes('Vegan') || dietary.includes('Made without gluten'))) {
    if (copy.note_dietary_soon) r.notes.push(copy.note_dietary_soon);
    if (!links.some((l) => l.url.indexOf('/pages/bespoke-enquiry') === 0)) links.push(L(C('ask_allergies', 'Ask us'), enquiry()));
  }
  if (!links.length) links = [L(C('browse_cakes', 'Browse our cakes'), '/collections/cakes')];

  if (s.timing === 'In the next few days' && s.fulfil !== 'Posted to me' && has('need-it-soon') && browse(links[0].url)) {
    links.unshift(L(C('soon', 'See what we can make in time'), '/collections/need-it-soon'));
  }

  const tag = { 'Collect from Brockley': 'fulfil-collection', 'Local delivery': 'fulfil-local-delivery' }[s.fulfil];
  if (tag) {
    links = links.map((l) => (handleOf(l.url) && handleOf(l.url) !== 'nationwide' ? L(l.label, l.url + '/' + tag) : l));
  }

  r.primary = links[0];
  r.secondary = links.slice(1, 3);
  r.equal = r.equal && r.secondary.length > 0 && r.secondary[0].url.indexOf('/pages/bespoke-enquiry') === 0;
  return r;
};
